import React from 'react';
import CustomContainer from "../Components/CustomContainer";
import Loader from "../Components/Loader";
import { Breadcrumb } from "react-bootstrap";
import { generatePath, useParams } from "react-router-dom";
import CustomTranslation from "../Components/CustomTranslation";
import Project from "../Home/Components/Project";
import Uuid from "uuid/v1";
import ConstructionSiteAction from "../../Actions/ConstructionSiteAction";
import ConstructionSiteWrapper from "../Components/ConstructionSiteWrapper";
import { Collapse } from "react-collapse";
import AssignmentAction from "../../Actions/AssignmentAction";
import Assignment from "../Assignment/Components/Assignment";
import UserAction from "../../Actions/UserAction";
import CompanyAction from "../../Actions/CompanyAction";

class AssignmentScreen extends React.Component {

    //constructor
    constructor(props) {
        super(props);

        this.csIds = [];
        this.constructionSites = [];

        //set state
        this.state = {
            assignments: [],
            toMeCollapsed: true,
            byMeCollapsed: true,
            conceptCollapsed: true,
            allCollapsed: true,
            toMeUuid: Uuid(),
            byMeUuid: Uuid(),
            dataLoaded: false
        };
    }

    componentDidMount = () => {
        this.updateElements();
    }

    updateElements = async () => {

        //requests parallel
        let requests = [];
        //get assignments for user
        requests.push(AssignmentAction.getForTarget(null, 'dateRequested'));
        //get assignments of user
        requests.push(AssignmentAction.getForSender(null, 'dateRequested'));
        //get assignment concepts
        requests.push(AssignmentAction.getConcept(null, 'dateRequested'));

        //wait for results
        let results = await Promise.all(requests);

        /* ASSIGNMENTS */
        let assignmentsIn = results[0] || [];
        let assignmentsOut = results[1] || [];
        let assignmentConcepts = results[2] || [];

        //create assignment elements
        let assignmentInElements = [];
        let assignmentOutElements = [];
        let assignmentConceptElements = [];

        let assignmentsInUnfinished = 0;
        let assignmentsOutUnfinished = 0;

        //loop and get construction site Ids
        for (let element of assignmentsIn) {
            let csId = element.constructionSiteId;
            if (!this.csIds.includes(csId)) {
                this.csIds.push(csId);
            }
        }
        for (let element of assignmentsOut) {
            let csId = element.constructionSiteId;
            if (!this.csIds.includes(csId)) {
                this.csIds.push(csId);
            }
        }
        for (let element of assignmentConcepts) {
            let csId = element.constructionSiteId;
            if (!this.csIds.includes(csId)) {
                this.csIds.push(csId);
            }
        }

        //loop cs Ids and fetch construction sites (errorRedirect: false to silently handle inaccessible sites)
        let csRequests = [];
        for (let csId of this.csIds) {
            csRequests.push(
                ConstructionSiteAction.getConstructionSite(csId, false, false)
                    .catch(() => null)
            );
        }
        let csResults = await Promise.all(csRequests);
        for (let cs of csResults) {
            if (cs && cs.id && cs['@type'] !== 'hydra:Error') {
                this.constructionSites[cs.id] = cs;
            }
        }

        //loop and add
        for (let element of assignmentsIn) {
            const cs = this.constructionSites[element.constructionSiteId];
            assignmentInElements.push(
                <Assignment
                    className={'vertical-margin-3'}
                    key={Uuid()}
                    data={element}
                    constructionSite={cs}
                    main={true}
                />
            );

            if (!element.dateFinished) {
                assignmentsInUnfinished++;
            }
        }

        for (let element of assignmentsOut) {
            const cs = this.constructionSites[element.constructionSiteId];
            assignmentOutElements.push(
                <Assignment
                    className={'vertical-margin-3'}
                    key={Uuid()}
                    data={element}
                    constructionSite={cs}
                    type={'out'}
                    main={true}
                />
            );

            if (!element.dateFinished) {
                assignmentsOutUnfinished++;
            }
        }

        for (let element of assignmentConcepts) {
            const cs = this.constructionSites[element.constructionSiteId];
            assignmentConceptElements.push(
                <Assignment
                    className={'vertical-margin-3'}
                    key={Uuid()}
                    data={element}
                    constructionSite={cs}
                    type={'out'} //display recipient
                    edit={true}
                    main={true}
                />
            );
        }

        //set state
        this.setState({
            dataLoaded: true,
            assignmentsIn: assignmentInElements,
            assignmentsOut: assignmentOutElements,
            assignmentsInUnfinished: assignmentsInUnfinished,
            assignmentsOutUnfinished: assignmentsOutUnfinished,
            assignmentsConcept: assignmentConceptElements,
            toMeUuid: Uuid(),
            byMeUuid: Uuid(),
            conceptUuid: Uuid(),
            allUuid: Uuid()
        });
    }

    render = () => {
        if (this.state && this.state.dataLoaded) {
            return (
                <CustomContainer>
                    <div>
                        {/* Breadcrumb */}
                        <Breadcrumb className={'vertical-margin-2'}>
                            <Breadcrumb.Item
                                href={generatePath('/')}
                            >
                                <CustomTranslation value={'KEY.Home'} />
                            </Breadcrumb.Item>
                            <Breadcrumb.Item active>
                                <CustomTranslation value={'KEY.Assignment actions'} />
                            </Breadcrumb.Item>
                        </Breadcrumb>

                        {/* Title */}
                        <div>
                            <h1>
                                <CustomTranslation value={'KEY.Assignment actions'} />
                            </h1>
                        </div>

                        {/* Inbox */}
                        <div
                            className={'rounded bg-light vertical-margin-2'}
                        >
                            <div
                                className={'touchable vertical-padding-2 standard-padding-2'}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center'
                                }}
                                onClick={() => {
                                    this.setState({ toMeCollapsed: !this.state.toMeCollapsed });
                                }}
                            >
                                <i style={{ fontSize: '1.25rem' }} className={'las la-envelope-square icon'} />
                                <div style={{ flexGrow: 1, flexShrink: 1 }} className={'standard-padding-2'}>
                                    <h4 style={{ marginBottom: 0 }}>
                                        <CustomTranslation value={'KEY.Actions assigned to me'} /> <span className={'text-primary unbold'}>[{this.state.assignmentsInUnfinished}/{this.state.assignmentsIn.length}]</span>
                                    </h4>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    <i style={{ fontWeight: '900', fontSize: '1.25rem' }}
                                        className={this.state.toMeCollapsed ? 'las la-chevron-down' : 'las la-chevron-up'} />
                                </div>
                            </div>
                            <Collapse
                                isOpened={!this.state.toMeCollapsed}
                            >
                                <div className={'vertical-padding-2 standard-padding-2'} style={{ paddingTop: 0 }}>
                                    {/* Indicators */}
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 0 }} className={'vertical-margin-2'}>
                                        <div style={{ width: 15, height: 15 }} className={'bg-success rounded'} />
                                        <p style={{ marginBottom: 0, paddingBottom: 0 }} className={'standard-margin-2 label unbold'}><CustomTranslation
                                            value={'KEY.Finished'} /></p>
                                        <div style={{ width: 15, height: 15 }} className={'bg-primary rounded'} />
                                        <p style={{ marginBottom: 0, paddingBottom: 0 }} className={'standard-margin-2 label unbold'}><CustomTranslation
                                            value={'KEY.Open'} /></p>
                                    </div>
                                    <div>
                                        {/* Assignment list */}
                                        {this.state.assignmentsIn.length > 0 ?
                                            <div>
                                                {this.state.assignmentsIn}
                                            </div>
                                            :
                                            <h2><CustomTranslation value={'KEY.No assignments'} /></h2>
                                        }
                                    </div>
                                </div>
                            </Collapse>
                        </div>

                        {/* Outbox */}
                        <div
                            className={'rounded bg-light vertical-margin-2'}
                        >
                            <div
                                className={'touchable vertical-padding-2 standard-padding-2'}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center'
                                }}
                                onClick={() => {
                                    this.setState({ byMeCollapsed: !this.state.byMeCollapsed });
                                }}
                            >
                                <i style={{ fontSize: '1.25rem' }} className={'las la-share-square icon'} />
                                <div style={{ flexGrow: 1, flexShrink: 1 }} className={'standard-padding-2'}>
                                    <h4 style={{ marginBottom: 0 }}>
                                        <CustomTranslation value={'KEY.Actions assigned by me'} /> <span className={'text-primary unbold'}>[{this.state.assignmentsOutUnfinished}/{this.state.assignmentsOut.length}]</span>
                                    </h4>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    <i style={{ fontWeight: '900', fontSize: '1.25rem' }}
                                        className={this.state.byMeCollapsed ? 'las la-chevron-down' : 'las la-chevron-up'} />
                                </div>
                            </div>
                            <Collapse
                                isOpened={!this.state.byMeCollapsed}
                            >
                                <div className={'vertical-padding-2 standard-padding-2'} style={{ paddingTop: 0 }}>
                                    {/* Indicators */}
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 0 }} className={'vertical-margin-2'}>
                                        <div style={{ width: 15, height: 15 }} className={'bg-success rounded'} />
                                        <p style={{ marginBottom: 0, paddingBottom: 0 }} className={'standard-margin-2 label unbold'}><CustomTranslation
                                            value={'KEY.Finished'} /></p>
                                        <div style={{ width: 15, height: 15 }} className={'bg-primary rounded'} />
                                        <p style={{ marginBottom: 0, paddingBottom: 0 }} className={'standard-margin-2 label unbold'}><CustomTranslation
                                            value={'KEY.Open'} /></p>
                                    </div>
                                    <div>
                                        {/* Assignment list */}
                                        {this.state.assignmentsOut.length > 0 ?
                                            <div>
                                                {this.state.assignmentsOut}
                                            </div>
                                            :
                                            <h2><CustomTranslation value={'KEY.No assignments'} /></h2>
                                        }
                                    </div>
                                </div>
                            </Collapse>
                        </div>

                        {/* Concepts */}
                        {this.state.assignmentsConcept.length > 0 ?
                            <div
                                className={'rounded bg-light vertical-margin-2'}
                            >
                                <div
                                    className={'touchable vertical-padding-2 standard-padding-2'}
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center'
                                    }}
                                    onClick={() => {
                                        this.setState({ conceptCollapsed: !this.state.conceptCollapsed });
                                    }}
                                >
                                    <i style={{ fontSize: '1.25rem' }} className={'las la-pen-square icon'} />
                                    <div style={{ flexGrow: 1, flexShrink: 1 }} className={'standard-padding-2'}>
                                        <h4 style={{ marginBottom: 0 }}>
                                            <CustomTranslation value={'KEY.Concept actions'} /> <span className={'text-primary unbold'}>[{this.state.assignmentsConcept.length}]</span>
                                        </h4>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                        <i style={{ fontWeight: '900', fontSize: '1.25rem' }}
                                            className={this.state.conceptCollapsed ? 'las la-chevron-down' : 'las la-chevron-up'} />
                                    </div>
                                </div>
                                <Collapse
                                    isOpened={!this.state.conceptCollapsed}
                                >
                                    <div className={'vertical-padding-2 standard-padding-2'} style={{ paddingTop: 0 }}>
                                        {/* Indicators */}
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 0 }} className={'vertical-margin-2'}>
                                            <div style={{ width: 15, height: 15 }} className={'bg-success rounded'} />
                                            <p style={{ marginBottom: 0, paddingBottom: 0 }} className={'standard-margin-2 label unbold'}><CustomTranslation
                                                value={'KEY.Finished'} /></p>
                                            <div style={{ width: 15, height: 15 }} className={'bg-primary rounded'} />
                                            <p style={{ marginBottom: 0, paddingBottom: 0 }} className={'standard-margin-2 label unbold'}><CustomTranslation
                                                value={'KEY.Open'} /></p>
                                        </div>
                                        <div>
                                            {/* Assignment list */}
                                            {this.state.assignmentsConcept.length > 0 ?
                                                <div>
                                                    {this.state.assignmentsConcept}
                                                </div>
                                                :
                                                <h2><CustomTranslation value={'KEY.No assignments'} /></h2>
                                            }
                                        </div>
                                    </div>
                                </Collapse>
                            </div>
                            :
                            null
                        }
                    </div>
                </CustomContainer>
            );
        } else {
            return (
                <CustomContainer>
                    <Loader />
                </CustomContainer>
            );
        }
    }
}

//export
export default function (props) {
    const params = useParams();
    return <AssignmentScreen {...props} params={params} />;
}
